import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IMedData, ITechListData, IUserBase } from '../../types/type';
import { instance } from '../../api/api';

interface IAdminData {
  users: IUserBase[];
  selectedUser: IMedData | ITechListData | IUserBase | null;
  loaing: boolean;
  error: string | null;
}

const initialState: IAdminData = {
  users: [],
  selectedUser: null,
  loaing: false,
  error: null,
};

export const fetchAdminUsers = createAsyncThunk<IUserBase[]>('adminData/fetchUsers', async (_, { rejectWithValue }) => {
  try {
    const { data } = await instance.get<IUserBase[]>('/profiles');
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message ?? error.message ?? 'Unknown error');
  }
});

const adminDataSlice = createSlice({
  name: 'adminData',
  initialState,
  reducers: {
    setAdminData(state, action) {
      state.users = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminUsers.pending, (state) => {
        state.loaing = true;
      })
      .addCase(fetchAdminUsers.fulfilled, (state, action) => {
        state.users = action.payload;
        state.loaing = false;
      })
      .addCase(fetchAdminUsers.rejected, (state, action) => {
        state.error = action.error.message || 'Ошибка при загрузке пользователей';
        state.loaing = false;
      });
  },
});

export default adminDataSlice.reducer;
